"use client"

import React, { useRef, useEffect, useState } from 'react'
import { ReactLenis } from "lenis/dist/lenis-react";
import {
  motion,
  useMotionTemplate,
  useScroll,
  useTransform,
} from "framer-motion";




import backimage from '../assests/wedding_webp/1.webp';  
import f2 from '../assests/wedding_webp/002.webp';  
import f3 from '../assests/prewedding_webp/003.webp';  
import f4 from '../assests/prewedding_webp/009.webp';  

import wedding from '../assests/wedding_webp/01.webp';
import haldi from '../assests/haldi_webp/02.webp';
import pw from '../assests/prewedding_webp/004.webp';
import en from '../assests/babyshower_webp/v1.webp';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
};

export const SmoothScrollHero = () => {
  return (
    <div className="bg-zinc-950">
      <ReactLenis
        root
        options={{
          // Learn more -> https://github.com/darkroomengineering/lenis?tab=readme-ov-file#instance-settings
          lerp: 0.05,
          //   infinite: true,
          //   syncTouch: true,
        }}
      >
        
        <Hero />
        <div id='services'>
        <ImageStacking />
        </div>
      </ReactLenis>
    </div>
  );
};

const SECTION_HEIGHT = 1500;

const Hero = () => {
  return (
    <><div
      className="title mt-8 flex flex-col items-center justify-center text-center hidden sm:flex"
      style={{ fontFamily: "'madigan-light', sans-serif", width: '100%' }}
    >
      <h2 style={{ fontWeight: '400', textAlign: 'center' }} className="text-4xl sm:text-3xl lg:text-5xl font-fontc mt-8">
        Every Moment Matters
      </h2>
      <p className="text-2xl sm:text-4xl lg:text-3xl text-gray-600 mt-4">
        Capturing the emotions, love, and memories you'll cherish forever.
      </p>
    </div><div
      style={{ height: `calc(${SECTION_HEIGHT}px + 40vh)` }}
      className="relative w-full sm:h-[calc(1500px+65px)] h-[calc(1500px+40px)]"
    >
        <div
          className="title absolute mt-8 flex flex-col items-center justify-center text-center sm:hidden"
          style={{ fontFamily: "'madigan-light', sans-serif", width: '100%' }}
        >
          <h2 style={{ fontWeight: '400', textAlign: 'center' }} className="text-4xl sm:text-3xl lg:text-4xl font-fontc mt-8">
            Every Moment Matters
          </h2>
          <p className="text-2xl sm:text-4xl lg:text-3xl text-gray-600 mt-4">
            Capturing the emotions, love, and memories you'll cherish forever.
          </p>
        </div>
        <CenterImage />

        <ParallaxImages />

        <div className="absolute bottom-0 left-0 right-0 h-50" />
      </div></>
  );
};

const CenterImage = () => {
  const { scrollY } = useScroll();

  const clip1 = useTransform(scrollY, [0, 1500], [25, 0]);
  const clip2 = useTransform(scrollY, [0, 1500], [75, 100]);

  const clipPath = useMotionTemplate`polygon(${clip1}% ${clip1}%, ${clip2}% ${clip1}%, ${clip2}% ${clip2}%, ${clip1}% ${clip2}%)`;

  const backgroundSize = useTransform(
    scrollY,
    [0, SECTION_HEIGHT + 500],
    ["170%", "100%"]
  );
  const opacity = useTransform(
    scrollY,
    [SECTION_HEIGHT, SECTION_HEIGHT + 500],
    [1, 0]
  );

  return (
    <motion.div
      className="sticky top-0 h-screen w-full"
      style={{
        clipPath,
        backgroundSize,
        opacity,
        backgroundImage:`url(${backimage})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    />
  );
};

// const ParallaxImages = () => {
//   return (
//     <div className="mx-auto max-w-5xl px-4 pt-[200px]">
//       <ParallaxImg
//         src={f2}
//         alt="And example of a space launch"
//         start={-200}
//         end={200}
//         className="w-1/3"
//       />
//       <ParallaxImg
//         src={f3}
//         alt="An example of a space launch"
//         start={100}
//         end={-250}
//         className="mx-auto w-2/3 md:w-1/3"
//       />
//       <ParallaxImg
//         src={f4}
//         alt="Orbiting satellite"
//         start={-350}
//         end={-500}
//         className="ml-auto w-2/3 md:w-1/3"
//       />
//     </div>
//   );
// };

// const ParallaxImg = ({ className, alt, src, start, end }) => {
//   const ref = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: [`${start}px end`, `end ${end * -1}px`],
//   });

//   const opacity = useTransform(scrollYProgress, [0.75, 1], [1, 0]);
//   const scale = useTransform(scrollYProgress, [0.75, 1], [1, 0.85]);

//   const y = useTransform(scrollYProgress, [0, 1], [start, end]);
//   const transform = useMotionTemplate`translateY(${y}px) scale(${scale})`;

//   return (
//     <motion.img
//       src={src}
//       alt={alt}
//       className={className}
//       ref={ref}
//       style={{ transform, opacity }}
//     />
//   );
// };

const ParallaxImg = ({ className, alt, src, start, end, startMobile, endMobile }) => {
  const ref = useRef(null);

  // Detect mobile view using a custom hook
  const isMobile = useMediaQuery('(max-width: 768px)');
  const finalStart = isMobile && startMobile !== undefined ? startMobile : start;
  const finalEnd = isMobile && endMobile !== undefined ? endMobile : end;

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: [`${finalStart}px end`, `end ${finalEnd * -1}px`],
  });

  const opacity = useTransform(scrollYProgress, [0.75, 1], [1, 0]);
  const scale = useTransform(scrollYProgress, [0.75, 1], [1, 0.85]);

  const y = useTransform(scrollYProgress, [0, 1], [finalStart, finalEnd]);
  const transform = useMotionTemplate`translateY(${y}px) scale(${scale})`;

  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      ref={ref}
      style={{ transform, opacity }}
    />
  );
};

const ParallaxImages = () => {
  return (
    <div className="mx-auto max-w-5xl px-4 pt-[200px]">
      <ParallaxImg
        src={f2}
        alt="Photography"
        start={-200}
        end={200}
        className="w-1/3"
      />
      <ParallaxImg
        src={f3}
        alt="Photography"
        start={-350}
        end={-250}
        startMobile={100}
        endMobile={-250}
        className="mx-auto w-2/3 md:w-1/3"
      />
      <ParallaxImg
        src={f4}
        alt="Photography"
        start={-450}
        end={-500}
        startMobile={0} // Start at 0 on mobile
        endMobile={-400} // End at -400 on mobile
        className="ml-auto w-2/3 md:w-1/3"
      />
    </div>
  );
};




const images = [
   { src: wedding , name: "Wedding"},
   { src: haldi, name: "Haldi"},
   { src: pw, name: "Pre-Wedding"},
   { src: en, name: "BabyShower"},
]

const ImageStacking = () => {
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  
  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const viewportHeight = window.innerHeight;
        const totalCardHeight = images.length * 450; // 400px for image + 20px gap + 30px extra
        setContainerHeight(viewportHeight + totalCardHeight * 2); // Increased for more scroll space
      }
    };
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });
  
  return (
    <div 
      ref={containerRef} 
      className="relative" 
      style={{ height: `${containerHeight}px`}}
    >
      <div  className="sticky top-[85px] h-[105vh] sm:top-[100px] flex items-center justify-center overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 w-full">
          <div className="lg:flex lg:items-start lg:space-x-8">
            <div className="lg:w-2/3 mb-8 lg:mb-0">
              <h2 style={{fontWeight:'400'}} className="text-4xl font-fontc text-gray-900 mb-4 md:text-5xl">
                Our Services for Every Occasion
              </h2>
              <p className="text-xl text-gray-600 md:hidden">
                Explore a variety of services for your special moments
              </p>
              <p className="text-xl text-gray-600 md:flex hidden">
              Explore our beautifully captured moments across various events, from vibrant Haldi ceremonies to the elegance of Weddings, and everything in between.
              </p>
              <button><a className='md:inline-block hidden bg-gray-800 mt-8 text-white py-3 px-6 rounded-full transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-gray-400 ' href="https://api.whatsapp.com/send?phone=9130703656&text=Hello">Contact Now</a></button>
            </div>
            <div className="lg:w-2/3 relative h-[80vh]">
              {images.map((image, index) => (
                <StackedImage 
                  key={index} 
                  image={image} 
                  index={index} 
                  scrollYProgress={scrollYProgress}
                  totalImages={images.length}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StackedImage = ({ image, index, scrollYProgress, totalImages }) => {
  const cardHeight = 450; // height of the card + gap
  
  const startPoint = index * 0.25;
  const endPoint = startPoint + 0.25;

  const y = useTransform(
    scrollYProgress, 
    [0, startPoint, endPoint], 
    [index * cardHeight + 50, Math.max(0, (index - 1) * 50), 0]
  );

  // Add a random tilt effect, but not for the first image
  const tiltRange = index === 0 ? 0 : 5; // Maximum tilt in degrees
  const randomTilt = Math.random() * tiltRange * 2 - tiltRange; // Random value between -tiltRange and tiltRange
  const rotate = useTransform(
    scrollYProgress,
    [endPoint - 1, endPoint], // Start tilting effect near the end of movement
    [0, randomTilt]
  );

  return (
    <motion.div
      style={{
        y,
        rotate,
        zIndex: index + 1, // Ensure proper stacking order
      }}
      className="absolute left-0 right-0 mx-auto sm:w-80 md:w-96 lg:w-96 transition-all duration-300 ease-out"
    >
      <div className="bg-white shadow-sm overflow-hidden" style={{ padding: '10px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
        <div className="bg-white" style={{ padding: '5px', position: 'relative' }}>
          <img loading='lazy'
            src={image.src} 
            alt={image.name}
            className="w-full h-[400px] object-cover" 
            style={{
              borderBottom: '40px solid white', // Extra space for caption
            }}
          />
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            textAlign: 'center',
            fontFamily: "'madigan-light', sans-serif",
            padding: '0px 0px 4px 0px',
            fontSize: '1.2rem',
            backgroundColor: 'white',
            fontWeight: 'bold',
          }}>
            {image.name}
          </div>
        </div>
      </div>
    </motion.div>
  );
};









export default SmoothScrollHero;